export default {
  field__account_number: 'Номер счёта (IBAN)',
  field__account_holder: 'Имя владельца счёта',
  field__bank_name: 'Название банка',
  field__bank_ifsc_code: 'IFSC код банка',
  field__bank_code: 'Код банка',
  field__account_holder_address: 'Адрес владельца счёта',
  field__bank_address: 'Адрес банка',
  field__bic: 'BIC',
  field__purpose_of_payment: 'Назначение платежа',
  field__pay_id: 'PayID',
  card_last_four_digits: 'Последние четыре цифры карты',
  field__invoice_receipt_number: 'Номер квитанции инвойса',
};
